module.exports = __webpack_public_path__ + "Flag-592.4e49f5ecb228c3ba58f3f96f2109cde3.svg";